import { focusStyles } from "@starter/Themes/common/mixins/common";

export default {
    defaultProps: {
        css: focusStyles(),
    },
};
